import styled from 'styled-components';

import { coolGrey1 } from 'approot/shared/styles/colours.style';
import { flexColumnCss } from 'approot/shared/styles/flex.style';
import { font24, PStyled } from 'approot/shared/styles/typography.style';
import { rem } from 'approot/shared/style';
import { spacing24 } from 'approot/shared/styles/spacing.style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';

export const ClassResponseEmpty = styled.div`
  ${flexColumnCss}
  background-color: ${coolGrey1};
  border-radius: ${rem(borderRadius8)};
  padding: ${rem(100)} ${rem(spacing24)};
`;

export const ClassResponseEmptyText = styled(PStyled)`
  ${font24}
  text-align: center;
`;
